import Layout from '@/components/Layout';
import MenuBar from '@/components/MenuBar';
import Stack from '@mui/material/Stack';
import type { IconName } from 'lucide-react/dynamic';
import { lazy, useState } from 'react';
import { ToolsStack } from './style';
import Traceroute from './Traceroute';
import { useTranslation } from 'react-i18next';
const Latency = lazy(() => import('./Latency'));
//import { Content } from '../Dashboard/styles';

interface LinkItem {
  path: string;
  icon: IconName;
  label: string;
  action?: () => void;
}

function Tools() {
  const [currentTab, setCurrentTab] = useState('ping');
  const { t } = useTranslation();
  /**
   * List of navigation links for settings sections
   * Each item represents an available settings page
   */
  const links: LinkItem[] = [
    {
      path: '/ping',
      icon: 'arrow-up-down',
      label: t('tools.ping.title'),
      action: () => setCurrentTab('ping'),
    },
    {
      path: '/traceroute',
      icon: 'waypoints',
      label: t('tools.traceroute.title'),
      action: () => setCurrentTab('traceroute'),
    },
  ];

  return (
    <Layout noLeftMargin>
      <Stack width="100%" alignItems="center">
        <ToolsStack>
          <MenuBar links={links} currentPath={currentTab} />
          {currentTab === 'ping' && <Latency />}
          {currentTab === 'traceroute' && <Traceroute />}
        </ToolsStack>
      </Stack>
    </Layout>
  );
}

export default Tools;
